
        var result = require("!!../../../../../node_modules/css-loader/index.js!./electricity-statistics.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/electricity/electricity-statistics/electricity-statistics.component.css
// module id = 780
// module chunks = 0